/**
 * @file   名琴轩
 * @create macaiqi 2025/07/23
 * @update 
 */
import React, { useState, useEffect } from 'react';
import cls from 'classnames'
import img1 from '../../assets/images/mqx/mqx-bg1.png';
import img2 from '../../assets/images/mqx/mqx-bg2.png';
import hy from '../../assets/images/mqx/hy.png';
import xz from '../../assets/images/mqx/xz.png';
import qinshade from '../../assets/images/mqx/qinshade.png';
import ShiYang from './ShiYang';
import { queryArchivesList, queryArchivesById, queryFileList } from '../../service';
import { htmltoStr } from '../../utils';
import './index.scss'
// 形制
const XZShade = ({ setId, id }) => {
    const [data, setData] = useState()
    const [filedata, setFileData] = useState([])
    useEffect(() => {
        if (id) {
            queryArchivesById(id).then(res => {
                setData(res)
                console.log(res)
                queryFileList({
                    pagination: {
                        size: 0,
                        page: 0
                    },
                    params: {
                        groupId: res?.groupId,
                        code:
                            "CMS_ARCHIVES_FILE"
                    }
                }).then(res1 => {
                    console.log(res1?.records)
                    setFileData(res1?.records || [])
                })
            })
        }
    }, [id])
    return (
        <div className="shade animate__animated animate__fadeIn animate__fast">
            <i
                className="close1"
                onClick={() => {
                    setId();
                }}></i>
            <div className={cls("imgcontent")}>
                <div className="title">
                    {data?.title?.split("").map((item, index) => {
                        return (
                            <div key={index} className="txt">
                                <span>{item}</span>
                            </div>
                        )
                    })}
                </div>
                <div className="scroll">
                    <div className="des">
                        {htmltoStr(data?.content)}
                    </div>
                    {filedata?.map((item, index) => {
                        return (
                            <div className="item">
                                <img src={item.filePath} alt="" srcset="" key={index} />
                            </div>
                        )
                    })}
                </div>

            </div>

        </div>
    )
}
const XZ = ({ setShow }) => {
    const [data, setData] = useState([])
    const [id, setId] = useState()

    useEffect(() => {
        queryArchivesList({
            resource: 'XZ',
            pagination: {
                size: 0,
                page: 0
            }
        }).then(res => {
            setData(res?.records || [])
        })
    }, [])
    return (<div className="common-page xzdetail-page">
        <div
            className="back"
            onClick={() => {
                setShow();
            }}
        />
        <div className="title" />
        <div className="txt" />
        <div className="img1">
            {["龙龈", "冠角", "面板", "琴徽", "琴弦", "岳山", "承露"].map((item, index) => {
                return (
                    <div className="b" key={index} onClick={() => {
                        setId(data?.filter((a) => { return a.title === item })?.[0]?.id)
                    }}>{item}</div>
                )
            })}
        </div>
        <div className="img2">
            {["龈托", "雁足", "底板", "护轸", "槽腹"].map((item, index) => {
                return (
                    <div className="b" key={index} onClick={() => {
                        setId(data?.filter((a) => { return a.title === item })?.[0]?.id)
                    }}>{item}</div>
                )
            })}
        </div>
        <div className="img3">
            {["琴轸", "绒扣", "琴穗"].map((item, index) => {
                return (
                    <div className="b" key={index} onClick={() => {
                        setId(data?.filter((a) => { return a.title === item })?.[0]?.id)
                    }}>{item}</div>
                )
            })}
        </div>


        {id && <XZShade setId={setId} id={id} />}
    </div>)
}
export default function MQX({ setToPage }) {
    let floor = ["二层", "首层"];
    const [floorAt, setFloorAt] = useState(1); //1 首层  0二层
    const [show, setShow] = useState();
    const [showqin, setShowQin] = useState();  // 选中的琴

    return (
        <div className='common-page mqx-page '>
            <div
                className="back"
                onClick={() => {
                    setToPage();
                }}
            />
            <div className="floor">
                {floor.map((item, index) => {
                    return (
                        <div
                            className={cls("item", { active: index === floorAt })}
                            key={index}
                            onClick={() => {
                                setFloorAt(index);
                            }}
                        >
                            {item}
                            <i></i>
                        </div>
                    );
                })}
            </div>

            <div className="imgbox">
                {floorAt === 1 && <>
                    <img src={img1} alt="" className='bg' style={{ height: "67.5rem" }} />
                    <div
                        className="tosecend"
                        onClick={() => {
                            setFloorAt(0)
                        }}
                    ></div>
                    <div
                        className="common-hot hot1"
                        onClick={() => {
                            setShow("hot1");

                        }}
                    />
                    <div
                        className="common-talk animate__animated animate__pulse animate__slower	 animate__infinite"
                        onClick={() => {
                            setShow("talk");
                        }}
                    />
                    <div className="qinlist">
                        {["仲尼式", "落霞式", "连珠式", "列子式"].map((item, index) => {
                            return (

                                <div
                                    key={index}
                                    className="common-hot hotfloor1"
                                    onClick={() => {
                                        setShowQin(item)
                                    }}
                                />
                            )
                        })}

                    </div>



                    {/* 对话 */}
                    {show === "talk" && <div className="shade   animate__animated animate__fadeIn animate__fast">
                        <i
                            className="close"
                            onClick={() => {
                                setShow();
                            }}
                        ></i>
                        <img src={hy} alt="" style={{ width: "40.375rem", height: "14.8125rem" }} />
                    </div>}
                    {show === "hot1" && <div className="shade   animate__animated animate__fadeIn animate__fast">
                        <i
                            className="close"
                            onClick={() => {
                                setShow();
                            }}
                        ></i>
                        <img src={xz} alt="" style={{
                            width: "40.35rem"
                        }} />
                        <div className="btn" onClick={
                            () => {
                                setShow("xzdetail");
                            }
                        }>查看详情</div>
                    </div>}
                    {(show === "xzdetail") && <XZ setShow={setShow} />}


                </>}
                {floorAt === 0 && <>
                    <img src={img2} alt="" className='bg' style={{ height: "67.5rem" }} />
                    <div
                        className="go1"
                        onClick={() => {
                            setFloorAt(1);
                        }}
                    ></div>
                    <div className="qinlist">
                        {["蕉叶式", "伶官式", "伏羲式", "子期式"].map((item, index) => {
                            return (

                                <div
                                    key={index}
                                    className="common-hot hotfloor2"
                                    onClick={() => {
                                        setShowQin(item)
                                    }}
                                />
                            )
                        })}

                    </div>
                </>}

                {showqin && show !== "shiyangpage" && <div className="shade qin-shade   animate__animated animate__fadeIn animate__fast">
                    <i
                        className="close"
                        onClick={() => {
                            setShowQin();
                        }}
                    ></i>
                    <img src={qinshade} alt="" style={{ width: "27.5rem", height: "18.5rem" }} />
                    <div className="text">
                        这是一把【{showqin}】古琴。
                    </div>
                    <div className="btn" onClick={() => {
                        setShow("shiyangpage");
                    }}>查看详情</div>
                </div>}
                {show === "shiyangpage" && <ShiYang setShow={setShow} showqin={showqin} setShowQin={setShowQin} floorAt={floorAt} />}
            </div>

        </div >
    )
}
